import { selectJsonQuery } from 'shared/selectors/results';
import { fetchEtazhiBlackFridayDataIfNeeded } from 'shared/services/fetchEtazhiBlackFridayDataIfNeeded';
import { actionGenerator } from 'shared/utils/redux';

import type { IOffer } from 'shared/offer';
import type { ITypedReduxAction, TThunkAction } from 'shared/types/redux';

export enum EEtazhiBlackFridayActionTypes {
  SetPromoOffersData = 'EtazhiBlackFriday/SetPromoOffersData',
}

type TEtazhiBlackFridayDataSetAction = ITypedReduxAction<
  EEtazhiBlackFridayActionTypes.SetPromoOffersData,
  IOffer[] | null
>;

export type TEtazhiBlackFridayDataActions = TEtazhiBlackFridayDataSetAction;

export const setEtazhiBlackFridayData = actionGenerator<
  EEtazhiBlackFridayActionTypes.SetPromoOffersData,
  IOffer[] | null
>(EEtazhiBlackFridayActionTypes.SetPromoOffersData);

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export function getEtazhiBlackFridayPromoOffers(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { logger } = context;

    const state = getState();

    const jsonQuery = selectJsonQuery(state);

    try {
      const promoOffersData = await fetchEtazhiBlackFridayDataIfNeeded(context, {
        jsonQuery,
        getState,
      });

      dispatch(setEtazhiBlackFridayData(promoOffersData?.offersSerialized ?? null));
    } catch (error) {
      logger.error(error);
      dispatch(setEtazhiBlackFridayData(null));
    }
  };
}
